export const MicroblinkFunctions = {}

MicroblinkFunctions.doNextStage = (obj) => {
  let config = {
    pathname: `/${obj.nextComponent}`,
    state: {
      folioId: obj.folioId,
      actorId: obj.actorId,
      sectionId: obj.sectionId,
      sections: obj.sections,
      docName: obj.docName,
      sectionName: obj.sectionName,
      secCapture: obj.secCapture,
      pdf: obj.pdf,
      metadatos: obj.metadatos,
      docIds: obj.docIds,
      selfieMeta: obj.selfieMeta,
      transId: obj.transId,
      sequences: obj.sequences,
      selectedCapture: obj.selectedCapture,
      documetId: obj.documetId,
      capturedFingerCurrent: obj.capturedFingerCurrent,
      capturedFinger: obj.capturedFinger,
      capturedHandCurrent: obj.capturedHandCurrent,
      capturedHand: obj.capturedHand,
      isEvaluationDataCorrect: obj.isEvaluationDataCorrect,
      isEvaluationMinutiaeCorrect: obj.isEvaluationMinutiaeCorrect,
      metadataExtraccion: obj.metadataExtraccion,
      activeFacialVerification: obj.activeFacialVerification,
      activeGeolocation: obj.activeGeolocation,
      b64Document: obj.b64Document,
      qrProcess: obj.qrProcess,
      doc: obj.doc,
    }
  }

  console.log("config------------Identy doNextStage-----------------", config)
  obj.navigate(config)
}